/* ---------- MCC-001's -QA21 earth test, one PE core at a time (#3799, after CP-002's #3778) ----------
 * -QA21's motor has two cables, their PE cores on PE and PE2 of the outgoing terminals. The earth test read them in parallel, so one
 * core left off still passed; it now reads each core alone, the other lifted (onsite.ts): its readings are "core 1" and "core 2", no
 * longer "motor earth". A save made before holds the pair's reading under the old id in ui.commissions.u21, which the record would
 * drop unseen. How such a save is read: the save migration in packages/progress uses this (format 38). Self-contained on purpose, as
 * CP-002's earthcores.ts: the migration imports this file alone, not MCC-001's pack. -QA26's one cable keeps "motor earth". */

/** -QA21's old earth reading and the readings that replace it. */
export const MCC001_EARTH_CORES = { old: "motor earth", now: ["core 1", "core 2"] };

/** A commissioning record with the old earth reading put in its log ("changed", as a panel changed after the readings), the readings
 *  that replace it to be taken again (stale), and a signature over it dropped: the signed report no longer matches its tests. */
function record(c: any): any {
  const e = MCC001_EARTH_CORES;
  if (!c || typeof c !== "object" || !c.readings || typeof c.readings !== "object" || !(e.old in c.readings)) return c;
  const readings = { ...c.readings }, r = readings[e.old], stale = new Set<string>(Array.isArray(c.stale) ? c.stale : []);
  const log = [...(Array.isArray(c.log) ? c.log : []), { id: e.old, reading: r?.reading, pass: r?.pass, at: r?.at, why: "changed" }];
  delete readings[e.old]; e.now.forEach(id => stale.add(id));
  const out: any = { ...c, readings, log, stale: [...stale] }; delete out.signed;
  return out;
}
const one = <A extends { ui?: any }>(s: A): A => {
  const cs = s?.ui?.commissions, c = cs && typeof cs === "object" ? cs.u21 : undefined, r = record(c);
  return r === c ? s : { ...s, ui: { ...s.ui, commissions: { ...cs, u21: r } } };
};
/** A saved MCC-001 project with -QA21's earth reading moved to the per-core test: its own work and each earlier attempt it keeps. */
export function earthCoresMcc001Save<T extends { ui?: any; attempts?: any[] }>(s: T): T {
  const out = one(s);
  return Array.isArray(s?.attempts) ? { ...out, attempts: s.attempts.map(a => one(a)) } : out;
}
